import React, { useCallback } from "react";
import { makeStyles } from "@material-ui/core";
import IconButton from "pages/flyer/builder/components/Inspector/components/IconButton";
import { SECTIONS } from "pages/flyer/builder/constants";
import { VariablesIcon, LayersIcon, FileIcon, BrandKitIcon } from "./icons/newIcons";
import Users from "../Aside/components/Users";
import SidebarCreativeIcon from "components/icons/components/CreativeIcon";
import { authorization } from "module/auth";

interface IToolBar {
  store: any;
  selectedSection: null | string;
  setSelectedSection: (section: null | string) => void;
}

const Toolbar: React.FC<IToolBar> = ({ store, selectedSection, setSelectedSection }) => {
  const classes = useStyles();

  const handleClick = useCallback(
    (section: string) => {
      setSelectedSection(section);
    },
    [setSelectedSection]
  );

  const allSections = [
    { key: "settings", hint: "Design", section: SECTIONS.SETTINGS, Icon: SidebarCreativeIcon },
    // Image tab removed - now opens from BottomToolPanel ImageToolIcon
    // Drawing tab removed
    // Shapes tab removed - shapes are now available in BottomToolPanel
    // Icons tab removed - now opens from BottomToolPanel IconsToolIcon
    // QRCode tab removed - now opens from BottomToolPanel QRcodeIcon
    { key: "brand_kit", hint: "Brand Kit", section: SECTIONS.BRAND_KIT, Icon: BrandKitIcon },
    { key: "variables", hint: "Variables", section: SECTIONS.VARIABLES, Icon: VariablesIcon },
    { key: "layers", hint: "Layers", section: SECTIONS.LAYERS, Icon: LayersIcon },
    {
      key: "pdf",
      hint: "PDF",
      section: SECTIONS.IMPORT_PDF,
      Icon: FileIcon,
    },
    // {
    //   key: "ai_generation",
    //   hint: "AI",
    //   section: SECTIONS.AI_GENERATION,
    //   Icon: AIIcon,
    // },
  ];

  // Hide the PDF import tab for guests (no auth → no upload destination yet).
  const isGuest = !authorization.getUser?.()?.id;
  const sections = isGuest ? allSections.filter((s) => s.key !== "pdf") : allSections;

  return (
    <div className={classes.container}>
      <div className={classes.items}>
        {sections.map(({ key, hint, section, Icon }) => (
          <div key={`${key}-section`} data-tour={`sidebar-${key}`}>
            <IconButton hint={hint} isActive={selectedSection === section} onClick={() => handleClick(section)}>
              <Icon
                {...(key !== "settings" && { cypress_id: `${key}Icon` })}
                isActive={key === "settings" ? true : selectedSection === section}
              />
              <span className={classes.toolLabel}>{hint}</span>
            </IconButton>
          </div>
        ))}
      </div>
      <Users store={store} />
    </div>
  );
};

const useStyles = makeStyles({
  container: {
    background: "rgba(26, 37, 71, 1)",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "space-between",
    padding: 8,
  },
  items: {
    marginTop: "10px",
  },
  toolLabel: {
    fontFamily: "Inter, sans-serif",
    fontWeight: 600,
    lineHeight: "15px",
    fontSize: "12px",
    marginTop: "5px",
    color: "var(--color-surface-panel)",
    minWidth: "50px",
    textAlign: "center",
  },
});

export default Toolbar;
